<div fxFlex="100">
  <agm-map [latitude]="lat" [longitude]="lng" [mapTypeControl]="true" >
    <agm-marker *ngFor="let pos of list" [iconUrl]="pos.icon" [latitude]="pos.lat" [longitude]="pos.lng" (markerClick)="goToMDR(pos)"></agm-marker>
  </agm-map>
</div>
